/**
 * A router's `NavigationContext` navigator with `overrides` in place. A spread would freeze a
 * history's accessors (`location`, `index`, `action`) at the copy; copying their descriptors keeps
 * the current entry live through every wrapper for a reader such as `useRouteOverlayUrl`.
 */
export function overrideNavigator<T extends object>(navigator: T, overrides: Partial<T>): T {
    const copy = Object.defineProperties({}, Object.getOwnPropertyDescriptors(navigator)) as T;
    return Object.assign(copy, overrides);
}
